import moment from 'moment';

/**
 * 10000 => "10,000"
 * @param {number} num
 */
export function toThousandFilter(num) {
  return (+num || 0).toString().replace(/^-?\d+/g, m => m.replace(/(?=(?!\b)(\d{3})+$)/g, ','));
}

export function toDateFormat(date, format) {
  return date ? moment(date).format(format) : '';
}

export function subStr(value, start, end) {
  if (end) {
    return value ? value.toString().substring(start, end) : '';
  } else {
    return value ? value.toString().substring(start) : '';
  }
}

/**
* string 轉 Date
* @param {string} dateTime
* @param {string} format
*/
export function stringToDate(dateTime, format = 'yyyy/MM/dd') {
  const date = new Date(Date.parse(dateTime));
  const y = date.getFullYear();
  let m = date.getMonth() + 1;
  m = m < 10 ? '0' + m : m;
  let d = date.getDate();
  d = d < 10 ? ('0' + d) : d;

  let strDate = '';
  const dateFormat = format.split("/");
  for (let i = 0; i < dateFormat.length; i++) {
    switch (dateFormat[i]) {
      case 'yyyy':
        strDate += y;
        break;
      case 'MM':
        if (strDate.length > 0) strDate += '/';
        strDate += m;
        break;
      case 'dd':
        if (strDate.length > 0) strDate += '/';
        strDate += d;
        break;
    }
  }
  return strDate;
}